import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IHeaderAngularComp } from 'ag-grid-angular/main';
import { IHeaderParams } from 'ag-grid-community/main';

export interface FilterHeaderParams extends IHeaderParams {
    searchTerm: FormControl;
}

@Component({
    selector: 'filter-header',
    template: require('./filter-header.component.html'),
    styles: [require('./filter-header.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterHeaderComponent implements IHeaderAngularComp {

    public displayName: string;

    public searchTerm = new FormControl('');

    public agInit(params: FilterHeaderParams): void {
        this.displayName = `${params.displayName}...`;
        this.searchTerm = params.searchTerm;
    }
}